<template lang="html">
<div class="pgInner requireEdit">

    <div class="headBar">需求定制筛选</div>

    <div class="pgbody" :style="'height:' + pageH + 'px;'">

        <el-scrollbar ref="scroller" style="height:100%;">

            <div class="rowsLine clearfix">

                 <div class="iTerm">
                      <div class="iName">发布者</div>
                      <div class="iContent">{{itemDat.userName}}</div>
                 </div>

                 <div class="iTerm">
                      <div class="iName">所属企业</div>
                      <div class="iContent">{{itemDat.enterpriseName}}</div>
                 </div>

                 <div class="iTerm">
                      <div class="iName">发布时间</div>
                      <div class="iContent">{{itemDat.updatedAt}}</div>
                 </div>

            </div>

            <div class="rowsLine clearfix">

                  <div class="iTerm">
                       <div class="iName">需求类型</div>
                       <div class="iContent">
                          {{itemDat.demandType}}
                       </div>
                  </div>

                  <div class="iTerm">
                       <div class="iName">预算金额</div>
                       <div class="iContent">
                          {{itemDat.budgetAmount}}
                       </div>
                  </div>

            </div>

            <div class="rowsLine clearfix">

                  <div class="iTerm">
                       <div class="iName">联系人</div>
                       <div class="iContent">
                          {{itemDat.contactPerson}}
                       </div>
                  </div>

                  <div class="iTerm">
                       <div class="iName">联系电话</div>
                       <div class="iContent">
                          {{itemDat.contactPhone}}
                       </div>
                  </div>

            </div>

            <div class="rowsLine clearfix">

                  <div class="iTerm textTerm">
                       <div class="iName">需求内容</div>
                       <div class="iContent">
                            {{itemDat.demandContext}}
                       </div>
                  </div>

            </div>

            <div class="seekLine">
                <span>企业检索：</span>
                <div class="seekGp">
                  <el-select
                    style="width:100%;"
                    v-model="entId"
                    filterable
                    remote
                    placeholder="请输入关键词"
                    :remote-method="entSeek"
                    :loading="loading">
                      <el-option
                        v-for="item in entArr"
                        :key="item.id"
                        :label="item.companyName"
                        :value="item.id">
                      </el-option>
                    </el-select>
                </div>

                <el-button @click="entAdd" style="margin-left:12px;width:80px;" type="primary" size="medium" >添加</el-button>

            </div>

            <div class="tabLine">
              <el-table
                 :data="entList"
                 header-row-class-name="tableHead"
                 v-loading="loading"
                 style="width: 100%;margin-top:20px;">

                 <el-table-column
                   prop="enterpriseName"
                   label="企业">
                 </el-table-column>

                 <el-table-column
                   width="180"
                   align="center"
                   label="操作">
                   <template slot-scope="scope">

                       <div class="ibtn">
                         <span @click="remove(scope.row)">删除</span>
                       </div>

                   </template>
                 </el-table-column>
              </el-table>
            </div>

        </el-scrollbar>
    </div>

    <div class="pagefoot">

      <div v-if="pgState" class="loading">
           <span v-if="pgState == 1">初始化中...</span>
           <span v-if="pgState == 2">数据保存中...</span>
           <i class="el-icon-loading"></i>
      </div>
      <div v-else>
           <el-button @click="goReturn" plain size="small">取消</el-button>
           <el-button @click="directSave" type="primary" size="small">保存</el-button>
      </div>

    </div>

</div>
</template>

<script>

import { requireEntList,requireItem,requireListSave } from "@/api/enterprise/index";
import { getEnterpriseList } from "@/api/attes/attestation";

export default {
    data(){
        return{
            id:'',
            itemDat:{},

            entId:'',
            entList:[],
            entArr:[],

            params:{
                userId:'',
                no:1,
                size:20
            }
        }
    },

    methods:{
        goReturn:function(){
            this.$router.go(-1);
        },

        entAdd:function(){
            let vues = this;
            this.entArr.forEach(item => {
                if(this.entId == item.id){
                    var iParams = {
                        userId:this.itemDat.userId,
                        userName:this.itemDat.userName,
                        enterpriseId:item.id,
                        enterpriseName:item.companyName,
                        enterpriseCertificationStatus:item.enterpriseCertificationStatus,
                        corporateLogo:item.corporateLogo,
                        contactPerson:item.founder,
                        contactPhone:item.creatorMobilePhoneNumber,
                        myDemandCustomizationId:this.id
                    };
                    this.entList.push(iParams);
                    this.entId = '';
                    return;
                }
            })
        },

        remove:function(e){
            this.entArr.forEach((item,index) => {
                if(e.enterpriseId == item.id){
                    this.entList.splice(index,1);
                    return;
                }
            })
        },

        pageFix:function(){
            this.pageH = document.documentElement.clientHeight - 205;
        },

        entSeek:function(e){
            var vues = this;
            var key = e.replace(/\s+/g,'');
            if(key){
              getEnterpriseList({
                 status:'',
                 keyword:key,
                 sort:2,
                 no:1,
                 size:12
              }).then(res => {
                 vues.entArr = res.enterpriseList;
              })
            }
        },

        directSave:function(){
            requireListSave({
                myDemandCustomizationEnterpriseList:this.entList
            }).then(res => {
                this.$router.push('require_list');
            });
        },

        prevSet:function(){

            var vues = this;
            var querys = this.$route.query;

            this.id = querys.id;

            if(querys.id){

                requireItem({id:querys.id}).then(res => {
                    vues.itemDat = res.myDemandCustomization;
                });
                requireEntList({
                   size:500,
                   no:1,
                   myDemandCustomizationEnterpriseCondition:{
                       myDemandCustomizationId:querys.id
                   }
                }).then(res => {
                    vues.entList = res.myDemandCustomizationEnterpriseList;
                });
            }

            // 底部定位
            this.pageFix();
        },

    },
    created:function(){
        var vues = this;
        var querys = this.$route.query;

        this.prevSet();
        $(window).resize(function(){
    		     vues.pageFix();
             vues.$refs.scroller.$data.sizeHeight = this.pageH;
    	  })

    }


}
</script>

<style lang="scss" scoped>

.pgInner{
  background: #f5f5f5;
}

.headBar{
  height: 55px;
  line-height: 55px;
  font-size: 16px;
  padding-left: 20px;
  background: white;
}

.requireEdit .pgbody{
  margin: 20px;
  padding: 20px;
  font-size: 15px;
  background: white;
  overflow-y: scroll;
}

.rowsLine{
    margin-bottom: 30px;
    .iTerm{
        width: 32%;
        float: left;
        position: relative;
        .iName{
            width: 80px;
            float: left;
        }
        .iContent{
            margin-left: 80px;
            color:#999999;
        }
    }

    .textTerm{
        width: 50%;
    }
}

.seekLine{
    border-top: 1px solid #f8f8f8;
    padding-top: 30px;
}

.seekLine .seekGp{
    width: 30%;
    display: inline-block;
}

.pagefoot{
  height: 60px;
  line-height: 60px;
  background: white;
  padding-left: 20px;
  position: relative;
  z-index: 2;
  .btn{
    height: 32px;
    padding: 0 12px;
    margin-right: 12px;
    display: inline-block;
    font-size: 14px;
    cursor: pointer;
  }
  .type1{
    line-height: 32px;
    background: rgb(86, 119, 252);
    color: white;
  }
  .type2{
    box-sizing: border-box;
    border: 1px solid #aeaeae;
    line-height: 30px;
  }

  .loading{
     font-size: 14px;
     padding-left: 24px;
     color: #AEAEAE;
     i{
         font-size: 18px;
         vertical-align: middle;
     }
  }
}

.ibtn{
    display: inline-block;
    font-size: 14px;
    margin-right: 3px;
    span{
       cursor: pointer;
       color: #409EFF;
    }
}

</style>

<style lang="css">

.requireEdit .tableHead th{
   background: #efefef;
   font-weight: normal;
   color: #666666;
}

.requireEdit .el-input__inner{
  border-radius: 0px !important;
}

</style>



// WEBPACK FOOTER //
// requireEdit.vue?2ac0315e